"use strict";
(function (global) {
  global._validators = {

    'isRequired': {
      'handler': function (value, display) {
        if (!$.trim(value)) return false;
        return true;
      },
      'error': L("ERR_THIS_FIELD_IS_REQUIRED")
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    'isDate': {
      'handler': function (value, display) {
        if (!ParseDateTime(value)) return false;
        return true;
      },
      'error': L("ERR_THIS_FIELD_MUST_CONTAIN_DATE")
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    'isDigit': {
      'handler': function (value, display) {
        if (isNaN(value) && length!==1) return false;
        return true;
      },
      'error': L("ERR_THIS_FIELD_MUST_CONTAIN_DIGITS_ONLY")
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    'isNumber': {
      'handler': function (value, display) {
        if (isNaN(value)) return false;
        return true;
      },
      'error': L("ERR_THIS_FIELD_MUST_CONTAIN_NUMBERS_ONLY")
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    'isEmail': {
      'handler': function (value, display) {
        if (!validateEmail(value)) return false;
        return true;
      },
      'error': L("ERR_THIS_FIELD_MUST_CONTAIN_EMAIL_ADRESS_ONLY")
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    'min': {
      'handler': function (value, display, ruleValue) {
        if (value < ruleValue) return false;
        return true;
      },
      'error': L("ERR_THIS_FIELD_REQUIRE_A_GIVEN_MINIMUM")
    },

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    'max': {
      'handler': function (value, display, ruleValue) {
        if (value > ruleValue) return false;
        return true;
      },
      'error': L("ERR_THIS_FIELD_REQUIRE_A_GIVEN_MAXIMUM")
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  };

  var validateEmail = function (email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

})(window.WebAccess.components.forms.FormBuilder.prototype);